import { Box } from '@mui/material';
import React from 'react';
import { ConnectedMonitoringScreen } from '../../Device/Monitoring/ConnectedMonitoringScreen';

export default function ControlUnitMonitoringPage() {
  return (
    <Box sx={{ mb: 2 }}>
      <ConnectedMonitoringScreen />
    </Box>
  );
}
